var map = {
	"./iress-alert_45.entry.js": [
		7335,
		279,
		148,
		197,
		335
	],
	"./iress-backdrop.entry.js": [
		6853,
		853
	],
	"./iress-checkbox-mark.entry.js": [
		7574,
		574
	],
	"./iress-close-button.entry.js": [
		1316,
		279,
		316
	],
	"./iress-color-swatch.entry.js": [
		8657,
		279,
		197,
		657
	],
	"./iress-label.entry.js": [
		3269,
		279,
		269
	],
	"./iress-overlay-panel.entry.js": [
		8052,
		279,
		52
	],
	"./iress-placeholder.entry.js": [
		7926,
		279,
		926
	],
	"./iress-spinner.entry.js": [
		2010,
		279,
		10
	],
	"./iress-tag.entry.js": [
		4399,
		279,
		399
	],
	"./iress-toast.entry.js": [
		2916,
		279,
		148,
		916
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3984;
module.exports = webpackAsyncContext;